/*!
 init-compatibility
 Created by RuSsCiTy on 07.05.2018
 **/

//import "bootstrap";
export default function initCompatibility() {
  // Check for all compatibility you may need here

  console.log("init compatibility");

  if (!SLIM) {
    require("jquery");
    require("bootstrap");
    require("popper.js");
    require("../style/bootstrap-escaped.scss");
  }
  if (!window._babelPolyfill) {
    require("babel-polyfill");
  }
  $.fn.extend({
    animateCss: function(animationName, callback) {
      const element = this;
      let animationEnd =
        "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
      this.addClass(`animated ${animationName}`).one(animationEnd, function() {
        if (callback) {
          callback();
          callback = null;
        }
        $(element).removeClass(`animated ${animationName}`);
      });
      return this;
    }
  });

  return true;
}



// WEBPACK FOOTER //
// ./src-cookie-manager/init/compatibility.js